import gql from 'graphql-tag';

import { Mutation, Query } from 'core/index';

import { USER_ERROR_FIELDS } from 'core/errors';

export const POST_FIELDS = gql`
  fragment postFields on Post {
    id
    canUpdate
    canDelete
    title
    slug
    msg
    url
    lastUpdated
    dateCreated
    isUpvoted
    upvoteCount
    tags {
      id
      name
    }
    creatorProfile {
      id
      username
      preferredName
      avatar {
        id
        path
        url
      }
    }
    upvotes {
      id
      user {
        id
        username
        profile {
          id
          avatar {
            id
            path
            url
          }
        }
      }
    }
    commenters {
      id
      username
      avatar {
        id
        path
        url
      }
    }
    comments {
      totalCount
    }
  }
`;

export const POST_CONNECTION_FIELDS = gql`
  ${POST_FIELDS}
  fragment postConnectionFields on PostConnection {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
    totalCount
    edges {
      cursor
      node {
        ...postFields
      }
    }
  }
`;

export const POST_MUTATION = gql`
  ${POST_FIELDS}
  ${USER_ERROR_FIELDS}
  mutation Post($postInput: PostInput) {
    post(postData: $postInput) {
      post {
        ...postFields
      }
      userErrors {
        ...userErrorFields
      }
    }
  }
`;
export class PostMutation extends Mutation {
  static conf = {
    GQL: POST_MUTATION,
    inputName: 'postInput',
    resultPath: 'post.post',
    errorPath: 'post.userErrors',
  };
}

export const POST_QUERY = gql`
  ${POST_FIELDS}
  ${USER_ERROR_FIELDS}
  query Post($slug: String) {
    post(slug: $slug) {
      result {
        ...postFields
      }
      userErrors {
        ...userErrorFields
      }
    }
  }
`;
export class PostQuery extends Query {
  static conf = {
    GQL: POST_QUERY,
    varNames: ['slug'],
    resultPath: 'post.result',
    errorPath: 'post.userErrors',
  };
}

export const POSTS = gql`
  ${POST_CONNECTION_FIELDS}
  query HomePosts($batchSize: Int, $cursor: String, $sortBy: String) {
    posts(first: $batchSize, after: $cursor, sortBy: $sortBy) {
      ...postConnectionFields
    }
  }
`;
export class PostsQuery extends Query {
  static conf = {
    GQL: POSTS,
    varNames: ['batchSize', 'cursor', 'sortBy'],
    resultPath: 'posts',
  };
}

export const CHANNEL_POSTS = gql`
  ${POST_CONNECTION_FIELDS}
  query ChannelPosts(
    $slug: String
    $cursor: String
    $sortBy: String
    $batchSize: Int
  ) {
    posts(slug: $slug, first: $batchSize, after: $cursor, sortBy: $sortBy) {
      ...postConnectionFields
    }
  }
`;
export class ChannelPostsQuery extends Query {
  static conf = {
    GQL: CHANNEL_POSTS,
    varNames: ['slug', 'cursor', 'sortBy', 'batchSize'],
    resultPath: 'posts',
  };
}
